import React from "react";
import { Confirm } from "@culturehq/components";
import { useModal } from "app/context/ModalContext";

const ChqModalConfirm = ({ children, ...props }) => {
  const { registerModal } = useModal() || {};

  return (
    <Confirm {...props} registerModal={registerModal}>
      {children}
    </Confirm>
  );
};

export default ChqModalConfirm;
